import { render, staticRenderFns } from "./TranscriptionDetails.vue?vue&type=template&id=8087560c&scoped=true&"
import script from "./TranscriptionDetails.vue?vue&type=script&lang=js&"
export * from "./TranscriptionDetails.vue?vue&type=script&lang=js&"
import style0 from "./TranscriptionDetails.vue?vue&type=style&index=0&id=8087560c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8087560c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VContainer,VRow,VSwitch})
